/**
 * App-wide overlay stacking order.
 *
 * Every overlay in the app (`BaseModal`, `BaseConfirmDialog`, `BaseToastContainer`) renders
 * through `<Teleport to="body">`, so they all land as siblings of `#app` in one stacking
 * context and nothing but z-index decides who wins. Toasts therefore have to outrank the
 * highest modal tier — at 10000 they sat *under* the 10050 confirm-dialog backdrop and its
 * `backdrop-filter: blur(4px)`, which is what made them look like nothing happened.
 *
 * Add new overlay tiers here rather than inlining a number at the call site.
 */

/** Header popovers (NOTIF-003: the notification bell panel) — above page content, below every modal. */
export const OVERLAY_Z_POPOVER = 9000

/** `BaseModal` default backdrop. */
export const OVERLAY_Z_MODAL = 9999

/** `BaseConfirmDialog` — sits above a plain modal so it can confirm on top of one. */
export const OVERLAY_Z_CONFIRM_DIALOG = 10050

/** `SdGandalfAlert` — blocking alert, above confirm dialogs. */
export const OVERLAY_Z_ALERT = 10060

/**
 * Toasts. Must stay above every tier above.
 * Mirrored as `--z-toast` in `src/style.css` for the vue-toastification container, which
 * mounts itself and takes no props; `overlayStacking.test.ts` guards the two against drift.
 */
export const OVERLAY_Z_TOAST = 10100
